module.exports = __webpack_public_path__ + "img/logo-eng-blue.e00564c7.svg";